import React from "react";
import image from '../../../images/situation/maten/kozijn/S.jpg'
import PropTypes from "prop-types";

MaatS.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
    onEnter: PropTypes.func.isRequired
}
export default function MaatS(props) {
    return <div className="phone-page-middle">
        <div className="phone-situation-title">
            Voor kaderluiken zoals paneel- of louvreluiken vult u hier de stijlbreedte (S) in mm in.<br/>
            Deze maat geld voor alle situaties.<br/>
        </div>
        <input
            className="phoneInput"
            onChange={props.onChange}
            value={props.value}
            type="number"
            inputMode="numeric"
            onKeyDown={event => event.key === 'Enter' ? props.onEnter() : null}
            placeholder="Vul hier de maat in..."
        />
        <img className="explainImagePhone" src={image} alt=""/>
    </div>;
}